<template>
  <div
      class="append-filters__container q-container-fluid q-pb-2 q-col-12 q-col-sm-6 q-col-md-3 q-d-block q-d-md-none q-pb-3 q-px-3 q-pb-sm-0">
    <button type="button"
            class="q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm"
            @click="appendFilters"
            :disabled="isLoading"
    >
      <span>{{ SmartSearchTranslations.autocomplete.seeMore }}</span>
      <span v-if="isLoading || (productIsLoading && isMobileView)"
            class="q-spinner-border q-spinner-border-sm q-ms-2" role="status" aria-hidden="true"></span>
      <span v-else v-show="serpStore.getTotalProducts"> ({{ serpStore.getTotalProducts }})</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {inject} from 'vue';
import {SmartSearchTranslationsInterface} from "@/core/types";

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const serpStore = useSerpResultsStore()

const {isLoading} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const {loading: productIsLoading} = storeToRefs(serpStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

const appendFilters = () => {
  filtersStore.hideFiltersOnMobile()
}
</script>


<style scoped>
button {
  width: 100%;
}

@-webkit-keyframes q-spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

@keyframes q-spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

.q-spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite q-spinner-border;
  animation: 0.75s linear infinite q-spinner-border;
}

.q-spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@-webkit-keyframes q-spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}

@keyframes q-spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}

.q-spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  -webkit-animation: 0.75s linear infinite spinner-grow;
  animation: 0.75s linear infinite spinner-grow;
}

.q-spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .q-spinner-border,
  .q-spinner-grow {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }
}

</style>
